export const INFO_ASIDE_ID = 'info-aside';
export const NOT_EFIRMA_KEY = 'not-efirma';
